import { registerDirectives } from '@/global/directives'

export default function globalRegister(vue) {
  registerDirectives(vue)
}
